import React, { useState } from "react";
import "./ProductTwo.scss";
import ProgressFullBar from "../ProgressFullBar/ProgressFullBar";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { BASE_URL_IMAGE_Product } from "../../../../../Consts";
import {
    deleteProductImage,
    getProduct,
    updateProduct,
} from "../../../../../api/ProductApi/productSlice";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useAlert } from "react-alert";

const ProductTwo = ({ onPrev, setImages, images, product, data }) => {
    const dispatch = useDispatch();
    const alert    = useAlert();
    const id       = useParams().id;

    const [newImages,     setNewImages]     = useState([]);
    const [displayImages, setDisplayImages] = useState(product?.images ?? []);

    /* ── delete existing DB image or new local image ─────────────────── */
    const handleDelete = (image, index) => {
        if (!image.id) {
            // local-only image (not yet saved) — remove from display + newImages
            const updatedNew     = newImages.filter((_, i) => i !== index);
            const updatedDisplay = displayImages.filter((_, i) => i !== index);
            setNewImages(updatedNew);
            setDisplayImages(updatedDisplay);
            setImages(updatedNew);
        } else {
            // saved DB image — call delete API
            dispatch(deleteProductImage(image.id))
                .unwrap()
                .then((result) => {
                    alert.show("Sucessful Deleted");
                    dispatch(getProduct(id));
                    console.log(result);
                })
                .catch((err) => {
                    alert.show(err?.response?.data?.message ?? "Delete failed.");
                    console.log(err);
                });
        }
    };

    /* ── add newly selected files to display + newImages ─────────────── */
    const handleAdd = () => {
        setDisplayImages([...displayImages, ...images]);
        setNewImages([...newImages, ...images]);
    };

    /* ── submit update ───────────────────────────────────────────────── */
    const handleUpdate = () => {
        const formData = new FormData();

        // ── scalar fields ──────────────────────────────────────────────
        formData.append("name",        data.name        ?? "");
        formData.append("description", data.description ?? "");
        formData.append("model_no",    data.model_no     ?? "");
        formData.append("location",    data.location     ?? "");
        formData.append("language_id", data.language_id  ?? "");
        formData.append("seo",         data.seo          ?? "");
        formData.append("is_active",   data.is_active    ?? 0);
        formData.append("featured",    data.featured     ?? 0);

        // ── categories ─────────────────────────────────────────────────
        (data.categories ?? []).forEach((catId) =>
            formData.append("categories[]", catId)
        );

        // ── new images only (existing ones already live in DB) ─────────
        newImages.forEach((file, index) =>
            formData.append(`image[${index}]`, file, file.name)
        );

        // ── specifications ─────────────────────────────────────────────
        // spec shape is { label, value } from UI state
        // fall back to spec.key in case raw DB shape slipped through
        (data.specifications ?? []).forEach((spec, index) => {
            const keyVal = spec.label ?? spec.key ?? "";
            const valVal = spec.value ?? "";
            if (keyVal || valVal) {
                formData.append(`specifications[${index}][key]`,   keyVal);
                formData.append(`specifications[${index}][value]`, valVal);
            }
        });

        dispatch(updateProduct({ id, productData: formData }))
            .unwrap()
            .then((result) => {
                alert.show("Sucessful Updated");
                console.log(result);
            })
            .catch((err) => {
                alert.show(err?.response?.data?.message ?? "Something went wrong.");
                console.log(err);
            });
    };

    /* ── table rows ──────────────────────────────────────────────────── */
    const rows = displayImages.map((image, index) => ({
        id: index + 1,
        image: (
            <img
                style={{ width: "50px", height: "50px" }}
                src={
                    image.id
                        ? `${BASE_URL_IMAGE_Product}/${image.image}`          // existing DB image
                        : URL.createObjectURL(image)                           // new local file
                }
                alt=""
            />
        ),
        action: (
            <button className="button2" onClick={() => handleDelete(image, index)}>
                Delete
            </button>
        ),
    }));

    return (
        <div>
            <div>
                <ProgressFullBar showImage={true} showSpec={false} completed={65} />
            </div>
            <div className="ProductTwoContainer">

                <div className="addinput">
                    <input
                        type="file"
                        required
                        multiple
                        accept="image/*"
                        onChange={(e) => {
                            setImages(Array.from(e.target.files));
                            setNewImages([]);
                        }}
                    />
                    <button onClick={handleAdd}>Add</button>
                </div>

                <div className="">
                    <TableContainer>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>#</TableCell>
                                    <TableCell align="right">Image</TableCell>
                                    <TableCell align="right"></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows.map((row) => (
                                    <TableRow
                                        key={row.id}
                                        sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                    >
                                        <TableCell component="th" scope="row">{row.id}</TableCell>
                                        <TableCell align="right">{row.image}</TableCell>
                                        <TableCell align="right">{row.action}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>

                <div className="backandnext">
                    <button onClick={onPrev}>Back</button>
                    <button onClick={handleUpdate}>Update</button>
                </div>

            </div>
        </div>
    );
};

export default ProductTwo;